import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnChanges,
  output,
  SimpleChanges,
} from '@angular/core';
import {
  ButtonTypes,
  CcdlBrandComponent,
  CcdlButtonComponent,
  CcdlMenuDropdownComponent,
  CcdlNavBarComponent,
  CcdlNavList,
  DropdownList,
  NavList,
  SelectedOption,
} from '@cpm-pr1618001/ng-design-lib';
import { UserDialogView } from '../landing-page.modal';

@Component({
  selector: 'header-ui',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CcdlBrandComponent,
    CcdlButtonComponent,
    CcdlMenuDropdownComponent,
    CcdlNavBarComponent,
  ],
  standalone: true,
})
export class HeaderComponent implements OnChanges {
  private readonly destroyRef = inject(DestroyRef);

  @Input() userDialogView: UserDialogView;
  @Input() mobileNavigationMenu: DropdownList[] = [];
  @Input() desktopNavigationMenu: NavList[] = [];

  userDialogViewEvent = output<UserDialogView>();

  readonly brandMobileSrc: string = 'assets/images/capvizon_logo_ylw.png';
  readonly brandDesktopSrc: string = 'assets/images/capvizon_brand_logo.png';
  readonly brandHomeRoute: string = '/LandingPage/Home';

  signInBtnType: ButtonTypes = 'default';
  signUpBtnType: ButtonTypes = 'default';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.userDialogView?.currentValue) {
      this.updateActiveBtn();
    }
  }

  selectedOnDesktopNav(nav: CcdlNavList): void {}

  selectedOnMobileOption(event: SelectedOption): void {
    if (event.id === 3) {
      this.userDialogViewEvent.emit(UserDialogView.SIGN_IN);
    } else if (event.id === 4) {
      this.userDialogViewEvent.emit(UserDialogView.SIGN_UP);
    }
  }

  signInClick(): void {
    this.userDialogViewEvent.emit(UserDialogView.SIGN_IN);
  }

  signUpClick(): void {
    this.userDialogViewEvent.emit(UserDialogView.SIGN_UP);
  }

  updateActiveBtn(): void {
    this.signInBtnType =
      this.userDialogView === UserDialogView.SIGN_IN ? 'primary' : 'default';
    this.signUpBtnType =
      this.userDialogView === UserDialogView.SIGN_UP ? 'primary' : 'default';
  }
}
